import CheckboxHierarchy from "./CheckboxHierarchy";
import { CheckboxHierarchyProps, DataProps } from "./type";

export default CheckboxHierarchy;
export type { CheckboxHierarchyProps, DataProps };
